import { Tag, TagLabel, Box, Tooltip, TagProps } from '@chakra-ui/react';
import { ITag, TagType } from 'types';

export const UKTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  const tagType = tag.type;
  return (
    <Tooltip
      hasArrow
      placement="bottom"
      label={tag.type === TagType.OVER_12_MONTHS_UK ? <Over12Months /> : <Less12Months />}
    >
      <Tag
        size="xs"
        variant="solid"
        data-selector={`tag-uk-resident-${
          tagType === TagType.OVER_12_MONTHS_UK ? 'over-12-months' : 'under-12-months'
        }`}
        {...tagProps}
      >
        <Box
          bgColor="white"
          color="gray.500"
          borderRadius="sm"
          fontSize="3xs"
          fontWeight="bold"
          letterSpacing="tight"
          lineHeight="3"
          mr="0.5"
          px="1px"
          py="1px"
        >
          UK
        </Box>

        <TagLabel>{tag.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

const Over12Months = () => {
  return (
    <>
      Applying from the UK
      <br /> In country over 12 months
    </>
  );
};

const Less12Months = () => {
  return (
    <>
      Applying from the UK
      <br /> In country less than 12 months
    </>
  );
};
